<template>
    <TabView class="p-tabview-panel	col-12 md:col-12">
        <TabPanel v-for="localEscola in tabs" :key="localEscola.nome" :header="localEscola.nome">
            <TabView class="col-12 md:col-12" scrollable>
                <TabPanel v-for="andar in localEscola.andares" :key="andar.id" :header="'Andar: ' + andar.numero">
                    <DataTable :value="andar.salas" :selection.sync="selectedSala" @row-select="onRowSelectd"
                        selectionMode="single" class="p-datatable-sm p-datatable-gridlines p-datatable-striped" dataKey="id"
                        responsiveLayout="scroll">
                        <Column field="numero" header="Sala" :headerStyle="{ width: '3rem' }" />
                        <Column field="qtLugares" header="Lugares" :headerStyle="{ width: '4rem' }" />
                        <Column field="qtCandidatos" header="Candidatos" :headerStyle="{ width: '6rem' }"/>
                        <Column field="salaExtra" header="Sala individual" :headerStyle="{ width: '6rem' }">
                            <template #body="slotProps">
                                {{ slotProps.data.salaExtra ? "Sim" : "Não" }}
                            </template>
                        </Column>
                        <Column field="area" header="Área" :headerStyle="{ width: '6rem' }" />
                    </DataTable>
                    <ListaCandidatos :inscritosDialog.sync="inscritosDialog" :inscricoes="inscricoes"/>
                </TabPanel>
            </TabView>
        </TabPanel>
    </TabView>
</template>

<script>

import InscricaoService from '../../service/InscricaoService';
import { tratamentoDeErros } from "@/tratamentoDeErros";
import ListaCandidatos from './ListaCandidatos.vue';

export default {
    mixins: [tratamentoDeErros],
    components: {ListaCandidatos},
    props: ["listaLocalProva"],

    data() {
        return {
            habilitaInscricoes: false,
            inscricaoService: null,
            estadoInscricaoService: null,
            // teste
            distribuicaoConcluida: true,
            // distribuicoes: [],
            inscricoes: [],
            selectedSala: null,
            inscritosDialog: false,
            // tabs: []
        };
    },
    computed:{
        tabs: function(){
            return this.listaLocalProva;
        }
    },
    created() {
        this.inscricaoService = new InscricaoService();
        this.$store.state.dlgLoading = true;
        console.log("Criado");
    },
    mounted() {
        console.log("Mounted");
        this.$store.state.dlgLoading = false;
    },
    watch:{
        localProva() {
            this.distribuicoes = this.localProva.andares;
        },
        listaLocalProva() {
            console.log("lista local", this.listaLocalProva);
            this.$emit('update:tabs', false);
        }
    },
    methods: {
        onRowSelectd(event) {
            if (event.data.id) {
                this.$store.state.dlgLoading = true;
                this.inscricaoService.getInscricaoSala(event.data.id)
                    .then((resposta) => {
                        // console.log("data ", resposta);
                        //const tmp = JSON.parse(JSON.stringify( resposta.data));
                        if (resposta.length) {
                            this.inscritosDialog = true;
                        } else {
                            this.$toast.add({
                                severity: "info",
                                summary: `Sem candidatos para esta sala`,
                                detail: "",
                                life: 3000,
                            });
                        }
                        this.inscricoes = resposta;
                        this.$store.state.dlgLoading = false;
                    })
                    .catch((erro) => {
                        this.messages = this.getMessagesError(erro);
                        this.$store.state.dlgLoading = false;
                    });
            }
        },
    },

};

</script>

<style>
</style>
